<template lang="pug">
  .page-phased-tournaments.page-list
    PageHead

    .page-list__filters(ref="content")
      Button.page-list__filters-button(is-secondary icon="filter" @click="toggleFilters")
        | {{ !isFiltersVisible ? $t('showFilters') : $t('hideFilters') }}
      .page-list__filters-items(v-if="!isMobile || isFiltersVisible")
        template(v-for="filter in filters" v-if="!filter.isHidden")
          RangeInput(
            v-if="filter.type === 'range'"
            :key="getFilterKey(filter)"
            :placeholder="filter.title"
            :value="filter.value"
            :currencies="filter.currencies"
            @input="onFilterChange(filter, $event)"
          )
          BaseSelect(
            v-else
            :key="getFilterKey(filter)"
            :placeholder="filter.title"
            :options="filter.options"
            :value="filter.value"
            :with-empty-value="filter.withEmptyValue"
            with-title
            @input="onFilterChange(filter, $event)"
          )

    .page__content
      TwoColumnsList.page__section.page-phased-tournaments__list(
        :tournaments="list"
        v-bind="listProps"
        card-component="PhasedTournamentCard"
      )
        template(v-slot:title)
          SectionTitle {{ $t('allPhased') }}
            template(v-slot:sort)
              BaseSelect(
                :placeholder="sort.title"
                :options="sort.options"
                :value="sort.value"
                :icon="sort.icon"
                :with-empty-value="false"
                @input="onSortChange($event)"
              )
            template(v-slot:buttons)
              Button(is-square :is-active="listProps.view === 'cells'" icon="cells" @click="setView('cells')")
              Button(is-square :is-active="listProps.view === 'list'" icon="list" @click="setView('list')")

        template(v-slot:empty)
          InfoMessage.page-list__info(:with-icon="false")
            | {{ $t('tournamentsWasNotFound') }}
            Button(is-bordered is-white @click="resetFilters") {{ $t('resetFilters') }}

      Pagination(
        v-if="pagesCount > 1"
        :per-page="perPage"
        :pages-count="pagesCount"
        :current-page="currentPage"
        @perPageChange="onPerPageChange"
        @pageChange="onPageChange"
      )

</template>

<script>
import { debounce } from 'throttle-debounce'
import PageListMixin from '~/mixins/PageList'
import { createMeta } from '~/utils/meta'
import TwoColumnsList from '~/components/TwoColumnsList/TwoColumnsList'

export default {
  name: 'PagePhasedTournaments',

  components: {
    TwoColumnsList
  },

  mixins: [PageListMixin],

  mounted () {
    this.debouncedUpdateTournaments = debounce(2000, this.updateTournaments)

    this.$socket.on(
      `mega-tournaments:${this.game.name}`,
      this.debouncedUpdateTournaments
    )
    this.gameName = this.game.name
  },

  beforeDestroy () {
    this.$socket.off(
      `mega-tournaments:${this.gameName}`,
      this.debouncedUpdateTournaments
    )
  },

  methods: {
    updateTournaments () {
      setTimeout(() => {
        if (this.$route.name !== 'phased-tournaments') {
          return
        }

        this.setQueryUrl({ isSocketUpdate: true })
      }, 500)
    },

    getFilterKey (filter) {
      let value
      if (typeof filter.value === 'object') {
        value = JSON.stringify(filter.value)
      } else {
        value = filter.value
      }
      return `${filter.name}_${value}`
    }
  },

  head () {
    const metaTitle = this.game.name === 'lichess' ? this.$t('lichessPhasedMetaTitle') : this.$t('phasedListMetaTitle', { game: this.game.extra_data.title })
    if (this.currentPage > 0) {
      return {
        title: metaTitle,
        meta: [
          { hid: 'robots', name: 'robots', content: 'noindex, follow' }
        ]
      }
    }

    if (this.game.name === 'lichess') {
      return createMeta.call(this, {
        title: this.$t('lichessPhasedMetaTitle'),
        description: this.$t('lichessPhasedMetaDescription'),

        sharingDescription: this.$t('platformDescription')
      })
    }

    return createMeta.call(this, {
      title: this.$t('phasedListMetaTitle', {
        game: this.game.extra_data.title
      }),
      description: this.$t('phasedListMetaDescription', {
        game: this.game.extra_data.title
      }),

      sharingDescription: this.$t('platformDescription')
    })
  }
}
</script>

<style lang="scss">
@import "~@/assets/styles/page-list";

.page-phased-tournaments__list {
  &:not(.--list) {
    margin-bottom: 32px;
  }

  margin-top: 8px;
}
</style>
